'use client'

import Select from 'react-select'
import clsx from 'classnames'
import { ComponentProps } from 'react'
import { ClearIndicator } from './ui/clear-indicator'
import styles from './select.module.scss'

type OptionType = Record<string, any>
type OptionsType = Array<OptionType>

type BaseSelectProps = ComponentProps<typeof Select>

export interface SelectProps extends BaseSelectProps {
  options: OptionsType
  emptyMessage: string
}

export const SearchableSelect = (props: SelectProps) => {
  const { options, className, emptyMessage, ...restProps } = props

  return (
    <Select
      classNames={{
        container: ({}) => clsx(styles.container, 'text text_type_t1', className),
        control: ({}) => styles.control,
        singleValue: ({}) => styles.singleValue,
        input: ({}) => clsx(styles.input, 'text text_type_t1'),
        dropdownIndicator: ({}) => clsx(styles.dropdownIndicator, 'text text_type_t1'),
        indicatorsContainer: ({}) => clsx(styles.indicatorsContainer, 'text text_type_t1'),
        menuList: ({}) => clsx(styles.menu, 'text text_type_t1 text_color_dark'),
        option: ({ isSelected }) => clsx(styles.option, { [styles.isSelected]: isSelected }),
        noOptionsMessage: ({}) => styles.noOptionsMessage,
      }}
      options={options}
      noOptionsMessage={props => (
        <span className="text text_type_t2 text_color_dark" {...props}>
          {emptyMessage}
        </span>
      )}
      components={{
        ClearIndicator,
      }}
      isSearchable
      isClearable
      {...restProps}
    />
  )
}
